import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ArrowRightSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowRightSmallIconPath";
import { ComponentNotificationBodyAssignedTitle } from "@fixa/notifications";
import styles from "../task-notification.module.css";
import { getBodyAssignerString } from "../utils/task-notification-body";
import { useNotificationString } from "../hooks/useNotificationString";

interface TaskNotificationBodyAssignedTitleProps extends ComponentNotificationBodyAssignedTitle {
  read: boolean;
}
const TaskNotificationBodyAssignedTitle = ({
  props: { title, oldAssignedTo, newAssignedTo },
}: TaskNotificationBodyAssignedTitleProps) => {
  const titleString = useNotificationString(title);
  const oldAssignedToString = getBodyAssignerString(oldAssignedTo);
  const newAssignedToString = getBodyAssignerString(newAssignedTo);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {!!titleString && (
          <div className={styles["task-notification-item-body-title"] ?? ""}>
            {titleString}
          </div>
        )}
        {!!oldAssignedToString && !!newAssignedToString && (
          <div>
            <span
              className={
                styles["task-notification-item-body-old-assigned"] ?? ""
              }
            >
              {oldAssignedToString}
            </span>
            <FixaSSRIcon paths={ArrowRightSmallIconPath} />
            <span>{newAssignedToString}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskNotificationBodyAssignedTitle;
